export default "__VITE_ASSET__C2NP$I_v__"